class LuzguruVentiladoresCalculator extends HTMLElement {
  connectedCallback() {
    this.currentStep = 1;
    this.totalSteps = 4;
    
    // Inputs del usuario
    this.selectedM2 = 15;
    this.selectedRoom = null;
    this.selectedType = null;
    this.selectedLight = null;

    // Inicializar elementos
    this.initWizard();
    this.initM2Controls();
    this.initPresets();
    this.initOptionCards();
    this.initNavButtons();
  }

  initWizard() {
    this.progressBar = this.querySelector('#lzProgressBar');
    this.wizardCard = this.querySelector('#lzWizardCard');
    this.diagnosticCard = this.querySelector('#lzDiagnosticCard');
    this.updateProgress();
  }

  // Sincronización avanzada de M2 (Input numérico + Range Slider)
  initM2Controls() {
    this.m2Input = this.querySelector('#lzTestM2');
    this.m2Range = this.querySelector('#lzTestM2Range');

    if (!this.m2Input || !this.m2Range) return;

    // Escuchar cambios en el input numérico
    this.m2Input.addEventListener('input', (e) => {
      let val = parseInt(e.target.value, 10);
      if (isNaN(val) || val <= 0) val = 1;
      if (val > 100) val = 100; // Capar a un límite razonable
      
      this.selectedM2 = val;
      this.m2Range.value = Math.min(val, 50); // El slider llega hasta 50
      
      this.syncPresets(val);
      this.updateNavState();
    });

    // Escuchar cambios en el slider
    this.m2Range.addEventListener('input', (e) => {
      const val = parseInt(e.target.value, 10);
      this.selectedM2 = val;
      this.m2Input.value = val;
      
      this.syncPresets(val);
      this.updateNavState();
    });
  }

  // Activar o desactivar botones predefinidos según el valor de m2
  syncPresets(m2) {
    const presets = this.querySelectorAll('.lz-preset-btn');
    presets.forEach(btn => {
      const btnM2 = parseInt(btn.getAttribute('data-m2'), 10);
      
      // Margen de tolerancia para asociar rangos a presets
      let isMatching = false;
      if (btnM2 === 9 && m2 <= 10) isMatching = true;
      else if (btnM2 === 15 && m2 > 10 && m2 <= 13) isMatching = true;
      else if (btnM2 === 18 && m2 > 13 && m2 <= 20) isMatching = true;
      else if (btnM2 === 25 && m2 > 20 && m2 <= 30) isMatching = true;
      else if (btnM2 === 35 && m2 > 30) isMatching = true;

      if (isMatching) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });
  }

  // Presets rápidos (Habitación Mini, Mediana, etc.)
  initPresets() {
    const presets = this.querySelectorAll('.lz-preset-btn');
    presets.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        presets.forEach(p => p.classList.remove('active'));
        btn.classList.add('active');
        
        const m2 = parseInt(btn.getAttribute('data-m2'), 10);
        this.selectedM2 = m2;
        
        if (this.m2Input) this.m2Input.value = m2;
        if (this.m2Range) this.m2Range.value = m2;
        
        // Auto-avanzar al paso 2
        setTimeout(() => {
          this.goToStep(2);
        }, 250);
      });
    });
  }

  // Selección de tarjetas de opciones (Ubicación, Tipo, Luz)
  initOptionCards() {
    const cards = this.querySelectorAll('.lz-option-card');
    cards.forEach(card => {
      card.addEventListener('click', (e) => {
        e.preventDefault();
        const groupName = card.getAttribute('name');
        const value = card.getAttribute('data-val');

        // Desmarcar hermanos
        this.querySelectorAll(`.lz-option-card[name="${groupName}"]`).forEach(c => {
          c.classList.remove('active');
        });
        card.classList.add('active');

        // Guardar selecciones
        if (groupName === 'lzRoom') {
          this.selectedRoom = value;
          setTimeout(() => this.goToStep(3), 250);
        } else if (groupName === 'lzType') {
          this.selectedType = value;
          setTimeout(() => this.goToStep(4), 250);
        } else if (groupName === 'lzLight') {
          this.selectedLight = value;
          // Finalizar automáticamente
          setTimeout(() => this.generateDiagnostic(), 300);
        }
        
        this.updateNavState();
      });
    });
  }

  initNavButtons() {
    this.prevBtn = this.querySelector('#lzPrevBtn');
    this.nextBtn = this.querySelector('#lzNextBtn');

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (this.currentStep > 1) {
          this.goToStep(this.currentStep - 1);
        }
      });
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (this.currentStep < this.totalSteps) {
          this.goToStep(this.currentStep + 1);
        } else {
          this.generateDiagnostic();
        }
      });
    }

    this.updateNavState();
  }

  goToStep(step) {
    if (step < 1 || step > this.totalSteps) return;

    // Cambiar pane activo
    this.querySelectorAll('.lz-step-pane').forEach(pane => {
      pane.classList.remove('active');
    });
    const targetPane = this.querySelector(`.lz-step-pane[data-step="${step}"]`);
    if (targetPane) targetPane.classList.add('active');

    // Cambiar stepper visual
    this.querySelectorAll('.lz-stepper-step').forEach(indicator => {
      const idx = parseInt(indicator.getAttribute('data-step-indicator'), 10);
      indicator.classList.remove('active', 'completed');
      if (idx === step) {
        indicator.classList.add('active');
      } else if (idx < step) {
        indicator.classList.add('completed');
      }
    });

    this.currentStep = step;
    this.updateProgress();
    this.updateNavState();
  }

  updateProgress() {
    if (this.progressBar) {
      const pct = (this.currentStep / this.totalSteps) * 100;
      this.progressBar.style.width = `${pct}%`;
    }
  }

  updateNavState() {
    if (!this.prevBtn || !this.nextBtn) return;

    // Visibilidad del botón Atrás
    if (this.currentStep === 1) {
      this.prevBtn.style.visibility = 'hidden';
    } else {
      this.prevBtn.style.visibility = 'visible';
    }

    // Texto del botón Siguiente
    if (this.currentStep === this.totalSteps) {
      this.nextBtn.innerHTML = 'Ver Diagnóstico <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>';
    } else {
      this.nextBtn.innerHTML = 'Siguiente <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>';
    }

    // Habilitar/Deshabilitar según la selección
    let isValid = true;
    if (this.currentStep === 2 && !this.selectedRoom) isValid = false;
    if (this.currentStep === 3 && !this.selectedType) isValid = false;
    if (this.currentStep === 4 && !this.selectedLight) isValid = false;

    this.nextBtn.disabled = !isValid;
    this.nextBtn.style.opacity = isValid ? '1' : '0.4';
    this.nextBtn.style.pointerEvents = isValid ? 'auto' : 'none';
  }

  // ============================================================
  // CÁLCULO Y GENERACIÓN DE DIAGNÓSTICO
  // ============================================================
  generateDiagnostic() {
    const m2 = this.selectedM2;
    const room = this.selectedRoom;
    const type = this.selectedType;
    const light = this.selectedLight;

    // Calcular medidas sugeridas
    let sizeText = "";
    let collectionLink = "/collections/ventiladores-luzguru";

    if (type.indexOf('techo') !== -1 || type === 'pie') {
      if (m2 < 10) sizeText = "Diámetro Mini (hasta 90 cm)";
      else if (m2 >= 10 && m2 < 13) sizeText = "Diámetro Pequeño (90–107 cm)";
      else if (m2 >= 13 && m2 <= 20) sizeText = "Diámetro Mediano (112–132 cm)";
      else if (m2 > 20 && m2 <= 30) sizeText = "Diámetro Grande (132–140 cm)";
      else sizeText = "Formato XL (más de 140 cm) o 2 unidades";

      // Links a colecciones
      if (type === 'techo-retractil') collectionLink = '/collections/ventiladores-techo-aspas-retractiles';
      else if (type === 'techo-sin-aspas') collectionLink = '/collections/ventiladores-sin-aspas-diseno-moderno';
      else if (type === 'techo-plafon') collectionLink = '/collections/ventiladores-techo-plafon';
      else if (type === 'techo-normal') collectionLink = '/collections/ventiladores-techo-aspas-normales';
      else if (type === 'pie') collectionLink = '/collections/ventiladores-de-pie';
    } else if (type === 'sobremesa') {
      sizeText = m2 < 10 ? "6–9 pulgadas (15–23 cm)" : "12+ pulgadas (30 cm+)";
      collectionLink = '/collections/ventiladores-sobremesa-pared';
    } else if (type === 'climatizador') {
      sizeText = m2 < 15 ? "Depósito de 3–5 litros" : "Depósito de 6–10 litros recomendados";
      collectionLink = '/collections/climatizadores-evaporativos-enfriadores-aire';
    } else {
      sizeText = "Ver dimensiones en descripción del producto";
    }

    // Motor y protección
    let motorText = "Motor DC altamente eficiente y duradero";
    if (room === 'dormitorio' || room === 'oficina') {
      motorText = "Motor DC estricto (ultra silencioso, menos de 35 dB)";
    } else if (room === 'exterior-abierto') {
      motorText = "Motor con protección IP55 obligatoria (resistencia a lluvia)";
    } else if (room === 'exterior-cubierto') {
      motorText = "Motor con protección IP44 (resistencia a humedad ambiental)";
    } else if (room === 'cocina') {
      motorText = "Motor DC con aspas lisas de fácil limpieza";
    }

    // Luz integrada
    let lightText = "Sin luz integrada";
    if (light === 'con-luz-cct') {
      lightText = "Luz regulable CCT (cambio de tono cálido/neutro/frío)";
    } else if (light === 'con-luz-fija') {
      lightText = "Placa LED integrada de luz fija";
    } else if (light === 'indiferente') {
      lightText = "Luz LED CCT o sin luz según preferencia estética";
    }

    // Función extra
    let extraText = "Función de temporizador nocturno";
    if (room === 'dormitorio') {
      extraText = "Temporizador de apagado automático + modo brisa nocturna";
    } else if (room === 'salon') {
      extraText = "Función inversa (modo invierno) para distribuir calefacción";
    } else if (room === 'exterior-cubierto' || room === 'exterior-abierto') {
      extraText = "Aspas de ABS resistentes al clima exterior (no usar madera)";
    }

    const minCaudal = Math.round(m2 * 8);
    const buyersPct = Math.min(95, 75 + Math.round(m2/2));

    // Guías personalizadas (Tab 2)
    let guiaTipo = "";
    if (type === 'techo-retractil') {
      guiaTipo = "<h4>Aspas Retráctiles</h4><ul><li><strong>Doble función:</strong> Lámpara moderna cuando está en reposo y despliega las aspas al encenderse.</li><li><strong>Silencio:</strong> Funcionan con motores DC súper silenciosos.</li><li><strong>Bajo mantenimiento:</strong> Acumulan menos polvo al esconder las aspas.</li></ul>";
    } else if (type === 'techo-normal') {
      guiaTipo = "<h4>Aspas Fijas</h4><ul><li><strong>Caudal máximo:</strong> El diseño tradicional que garantiza el mayor movimiento de flujo de aire continuo.</li><li><strong>Función inversa:</strong> Redirige el aire caliente en invierno ahorrando calefacción.</li><li><strong>Materiales:</strong> Permite aspas de madera para interior o ABS para exterior.</li></ul>";
    } else if (type === 'techo-plafon') {
      guiaTipo = "<h4>Tipo Plafón</h4><ul><li><strong>Techos bajos:</strong> No requiere tija. Queda pegado al techo, maximizando la seguridad.</li><li><strong>Fácil limpieza:</strong> Estructura cerrada ideal para cocinas.</li></ul>";
    } else if (type === 'techo-sin-aspas') {
      guiaTipo = "<h4>Sin Aspas (Bladeless)</h4><ul><li><strong>Brisa continua:</strong> Flujo de aire sin interrupciones ni ráfagas.</li><li><strong>Seguridad:</strong> Sin aspas móviles al descubierto, ideal con niños o literas.</li></ul>";
    } else if (type === 'pie') {
      guiaTipo = "<h4>Ventilador de Pie</h4><ul><li><strong>Sin instalación:</strong> Solo enchufar y encender. Muévelo donde quieras.</li></ul>";
    } else {
      guiaTipo = "<h4>Climatizadores / Nebulizadores</h4><ul><li><strong>Enfriamiento activo:</strong> Usan agua para rebajar la sensación térmica hasta 5°C.</li></ul>";
    }

    let guiaEstancia = "";
    if (room === 'dormitorio') {
      guiaEstancia = "<h4>En tu Dormitorio:</h4><p>Usa las velocidades 1 o 2 (modo susurro, <25dB) para no resecar la garganta y conciliar el sueño plácidamente. Programa el apagado automático a las 2 horas.</p>";
    } else if (room === 'salon') {
      guiaEstancia = "<h4>En tu Salón o Comedor:</h4><p>Elige un diámetro adecuado para cubrir toda el área de los sofás y la mesa de comedor. Activa el modo inverso en invierno para ahorrar un 15% en calefacción.</p>";
    } else if (room === 'cocina') {
      guiaEstancia = "<h4>En la Cocina:</h4><p>Usa aspas de plástico ABS para limpiarlas fácilmente con agua jabonosa. Evita aspas de madera natural debido a la grasa.</p>";
    } else if (room === 'exterior-cubierto' || room === 'exterior-abierto') {
      guiaEstancia = "<h4>En Exteriores:</h4><p>Es obligatorio contar con clasificación IP44 o IP55. Las aspas deben ser de ABS resistente a los rayos UV.</p>";
    } else {
      guiaEstancia = "<h4>En Oficina / Estudio:</h4><p>Coloca la orientación del aire indirecta para trabajar a gusto sin que vuelen los papeles.</p>";
    }

    // FAQs Dinámicas (Tab 3)
    let faqItem1 = {
      q: "¿El ventilador enfría la habitación?",
      a: "El ventilador enfría a las personas, no el aire. Mueve el flujo de aire y acelera la evaporación del sudor en nuestra piel, reduciendo la sensación térmica hasta 4°C. Apágalo al salir de la habitación."
    };
    let faqItem2 = {
      q: "¿Cuánto consume encendido toda la noche?",
      a: "Un ventilador con motor DC consume unos 30W. En 8 horas de uso consume tan solo 0.24 kWh. Esto equivale a menos de 0.04 € por noche. Ahorras más del 95% respecto al aire acondicionado."
    };
    let errorItem = {
      q: "Error común: Comprar un diámetro insuficiente",
      a: "Si el diámetro del ventilador es muy pequeño para tus metros cuadrados, no notarás la brisa y tendrás que ponerlo a máxima potencia haciendo más ruido. Sigue nuestra recomendación de diámetro.",
      isError: true
    };

    if (room === 'exterior-cubierto' || room === 'exterior-abierto') {
      faqItem1 = {
        q: "¿Puedo instalar un ventilador común en exteriores?",
        a: "No. Los ventiladores estándar no soportan la humedad directa del exterior. La lluvia o la condensación causarán problemas de corrosión y cortocircuitos. Necesitas modelos IP44 o IP55."
      };
      faqItem2 = {
        q: "¿Qué material de aspa es mejor para el exterior?",
        a: "El plástico ABS es el material idóneo para exteriores porque no se deforma con el calor ni la humedad. Evita siempre la madera natural fuera de casa."
      };
      errorItem = {
        q: "Error crítico: Ignorar el código de protección IP",
        a: "Para porches cubiertos necesitas como mínimo IP44. Para pérgolas o exteriores expuestos es obligatorio un grado IP55.",
        isError: true
      };
    } else if (room === 'dormitorio') {
      faqItem1 = {
        q: "¿Emitirá ruidos molestos por la noche?",
        a: "Los modelos de LuzGuru con motor DC emiten menos de 20 dB en sus velocidades nocturnas (1 y 2). Es un nivel de ruido inferior al de una biblioteca silenciosa, imperceptible para el oído humano."
      };
      errorItem = {
        q: "Error común: Comprar motor AC para el dormitorio",
        a: "Los motores AC suelen emitir un zumbido eléctrico residual que, aunque sea bajo, resulta molesto para dormir. Opta siempre por motores DC para dormitorios.",
        isError: true
      };
    }

    // RENDERIZAR RESULTADOS
    this.diagnosticCard.innerHTML = `
      <div class="lz-diagnostic-header">
        <h3>Diagnóstico Listo</h3>
        <p>Tu asesoría personalizada para una estancia de ${m2} m²</p>
      </div>

      <div class="lz-diagnostic-grid">
        <!-- Izquierda: Recomendación principal -->
        <div class="lz-diagnostic-summary">
          <div class="lz-diag-title-box">
            <span class="lz-diag-lbl">Tamaño Recomendado</span>
            <div class="lz-diag-val">${sizeText}</div>
          </div>
          <ul class="lz-diag-list">
            <li>
              <span class="lz-diag-check">✓</span>
              <div><strong>Motor y Protección:</strong> ${motorText}</div>
            </li>
            <li>
              <span class="lz-diag-check">✓</span>
              <div><strong>Iluminación:</strong> ${lightText}</div>
            </li>
            <li>
              <span class="lz-diag-check">✓</span>
              <div><strong>Función Clave:</strong> ${extraText}</div>
            </li>
          </ul>
          <div class="lz-diag-tip-box">
            💡 <strong>Tip Profesional:</strong> Para ventilar eficazmente ${m2} m² necesitas un caudal de aire de mínimo <strong>${minCaudal} m³/min</strong>. Compruébalo en la ficha de producto.
          </div>
        </div>

        <!-- Derecha: Pestañas interactivas -->
        <div class="lz-diagnostic-details">
          <nav class="lz-tabs-nav" role="tablist">
            <button type="button" class="lz-tab-btn active" data-tab="ahorro" role="tab" aria-selected="true">Ahorro</button>
            <button type="button" class="lz-tab-btn" data-tab="guia" role="tab" aria-selected="false">Guía de Uso</button>
            <button type="button" class="lz-tab-btn" data-tab="faqs" role="tab" aria-selected="false">FAQs</button>
          </nav>

          <!-- Tab Ahorro con gráfico animado -->
          <div class="lz-tab-content active" id="lz-tab-ahorro" role="tabpanel">
            <div class="lz-savings-chart">
              <div class="lz-chart-row">
                <div class="lz-chart-info">
                  <span class="lz-chart-label">Aire Acondicionado</span>
                  <span class="lz-chart-val">900W</span>
                </div>
                <div class="lz-chart-bar-bg">
                  <div class="lz-chart-bar ac-bar" data-width="100%" style="width: 0%;"></div>
                </div>
              </div>
              
              <div class="lz-chart-row">
                <div class="lz-chart-info">
                  <span class="lz-chart-label">Ventilador Motor AC</span>
                  <span class="lz-chart-val">60W</span>
                </div>
                <div class="lz-chart-bar-bg">
                  <div class="lz-chart-bar fan-ac-bar" data-width="25%" style="width: 0%;"></div>
                </div>
              </div>

              <div class="lz-chart-row highlight">
                <div class="lz-chart-info">
                  <span class="lz-chart-label">Ventilador Motor DC</span>
                  <span class="lz-chart-val">30W</span>
                </div>
                <div class="lz-chart-bar-bg">
                  <div class="lz-chart-bar fan-dc-bar" data-width="10%" style="width: 0%;"></div>
                </div>
              </div>
            </div>
            <p class="lz-savings-disclaimer">Un motor DC consume hasta un 90% menos de luz. El <strong>${buyersPct}%</strong> de usuarios eligen motor DC en esta configuración.</p>
          </div>

          <!-- Tab Guía -->
          <div class="lz-tab-content" id="lz-tab-guia" role="tabpanel">
            <div class="lz-guide-info-box">
              ${guiaTipo}
              <hr style="border: none; border-top: 1px solid var(--lz-border); margin: 0.8em 0;">
              ${guiaEstancia}
            </div>
          </div>

          <!-- Tab FAQs -->
          <div class="lz-tab-content" id="lz-tab-faqs" role="tabpanel">
            <details class="lz-compact-accordion">
              <summary>${faqItem1.q}</summary>
              <div class="lz-compact-accordion-content">${faqItem1.a}</div>
            </details>
            <details class="lz-compact-accordion">
              <summary>${faqItem2.q}</summary>
              <div class="lz-compact-accordion-content">${faqItem2.a}</div>
            </details>
            <details class="lz-compact-accordion error-type">
              <summary>⚠️ ${errorItem.q}</summary>
              <div class="lz-compact-accordion-content">${errorItem.a}</div>
            </details>
          </div>
        </div>
      </div>

      <!-- Footer del diagnóstico -->
      <div class="lz-diagnostic-footer">
        <button type="button" class="lz-restart-link" id="lzRestartBtn">
          ← Volver a calcular
        </button>
        <div class="lz-diag-actions">
          <a href="/policies/contact-information" class="lz-btn lz-btn-outline" target="_blank">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
            </svg>
            Consultar Experto
          </a>
          <a href="${collectionLink}" class="lz-btn lz-btn-primary-glow">
            Ver Modelos Recomendados
          </a>
        </div>
      </div>
    `;

    // Transición visual
    this.wizardCard.style.display = 'none';
    this.diagnosticCard.style.display = 'block';

    // Desencadenar la animación de las barras de ahorro
    setTimeout(() => {
      this.animateSavingsBars();
    }, 100);

    // Scroll suave
    setTimeout(() => {
      this.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }, 120);

    this.initTabs();

    // Evento reiniciar
    const restartBtn = this.querySelector('#lzRestartBtn');
    if (restartBtn) {
      restartBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.resetCalculator();
      });
    }
  }

  // Activa la animación del ancho de barras en la pestaña de Ahorro
  animateSavingsBars() {
    const bars = this.querySelectorAll('.lz-chart-bar');
    bars.forEach(bar => {
      const targetWidth = bar.getAttribute('data-width');
      bar.style.width = targetWidth;
    });
  }

  // Lógica de Tabs en el diagnóstico
  initTabs() {
    const tabBtns = this.querySelectorAll('.lz-tab-btn');
    tabBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const tabId = btn.getAttribute('data-tab');

        // Desactivar todos
        tabBtns.forEach(b => {
          b.classList.remove('active');
          b.setAttribute('aria-selected', 'false');
        });
        this.querySelectorAll('.lz-tab-content').forEach(c => {
          c.classList.remove('active');
        });

        // Activar seleccionado
        btn.classList.add('active');
        btn.setAttribute('aria-selected', 'true');
        const activeContent = this.querySelector(`#lz-tab-${tabId}`);
        if (activeContent) {
          activeContent.classList.add('active');
          
          // Re-animar barras si entra a la pestaña de Ahorro
          if (tabId === 'ahorro') {
            const bars = activeContent.querySelectorAll('.lz-chart-bar');
            bars.forEach(bar => {
              bar.style.width = '0%';
            });
            setTimeout(() => {
              this.animateSavingsBars();
            }, 50);
          }
        }
      });
    });
  }

  resetCalculator() {
    this.currentStep = 1;
    this.selectedM2 = 15;
    this.selectedRoom = null;
    this.selectedType = null;
    this.selectedLight = null;

    if (this.m2Input) this.m2Input.value = 15;
    if (this.m2Range) this.m2Range.value = 15;

    // Resetear clases activas en tarjetas
    this.querySelectorAll('.lz-option-card').forEach(card => card.classList.remove('active'));
    
    // Resetear presets
    this.querySelectorAll('.lz-preset-btn').forEach(btn => {
      if (parseInt(btn.getAttribute('data-m2'), 10) === 15) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });

    // Mostrar de nuevo el asistente
    this.diagnosticCard.style.display = 'none';
    this.wizardCard.style.display = 'block';

    this.goToStep(1);
  }
}

customElements.define('lg-ventiladores-calculator', LuzguruVentiladoresCalculator);
